// This file is part of the Angular application for managing SEO metadata.
import { Injectable, Inject, DOCUMENT } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Location } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class SeoService {
  constructor(
    private title: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private doc: Document,
    private location: Location
  ) {}

  updateMeta(pageTitle: string, description: string, canonicalPath?: string) {
    this.title.setTitle(pageTitle);
    this.meta.updateTag({ name: 'description', content: description });

    const baseUrl = 'https://www.sydneyadvancedendocrinology.com.au';
    const path = canonicalPath ?? this.location.prepareExternalUrl(this.location.path());
    const canonicalUrl = baseUrl + (path.startsWith('/') ? path : '/' + path);
    const link = this.doc.querySelector('link[rel="canonical"]');
    if (link instanceof HTMLLinkElement) {
      link.setAttribute('href', canonicalUrl);
    }
  }
}
